import { clientFetch } from 'app/utils/client-fetch';
import * as types from './types';
import config from 'app/config';

export const apiGetPrivacy = solutionId => {
    return clientFetch( {
        url: `${ config.PRIVACY_API_URL }/privacy/${ solutionId }`,
        type: types.GET_PRIVACY
    } );
};
export const apiPostPrivacy = solutionId => {
    return clientFetch( {
        url: `${ config.PRIVACY_API_URL }/privacy/${ solutionId }`,
        type: types.POST_PRIVACY,
        method: 'post'
    } );
};

export const apiGetSolutions = () =>
    clientFetch( {
        url: `${ config.SOLUTIONS_API_URL }/solutions`,
        type: types.GET_SOLUTIONS
    } );

export const apiPostActivateVersion = privacyId => {
    return clientFetch( {
        url: `${ config.PRIVACY_API_URL }/activate-privacy/${ privacyId }`,
        type: types.POST_PRIVACY,
        method: 'post'
    } );
};
